import React from 'react';
import { useSelector } from 'react-redux';

import { 
    Paper, 
    Stack, 
    Typography, 
    Radio, 
    FormControl, 
    FormLabel, 
    FormControlLabel, 
    RadioGroup, 
    Divider, 
    TableContainer, 
    TableHead, 
    Table,
    TableRow, 
    TableCell, 
    TableBody,
    Grid
} from '@mui/material';

import { 
    FaArrowCircleLeft,
    FaArrowCircleRight 
} from "react-icons/fa";
  
import { BiSave } from "react-icons/bi";
import { TextField, Autocomplete } from "@mui/material";
import swal from 'sweetalert';
import { removeAccents } from '../../../utils';

import { selectSemanaAlmuerzoActiva } from '../../../redux/Cafeteria/CafeteriaSlice';

export const SeleccionAlmuerzoListaEmpleados = ({
    categoriaAlmuerzoDiaEmpleado, 
    setStepPosition, 
    stepPosition, 
    diasSemanas, 
    seleccionMenuEmpleado,
    setSeleccionMenuEmpleado,
    resumenMenuState,
    sendDataToApi,
    disabledCategoriesFood,
    setDisabledCategoriesFood,
    setEmpleadosAlmuerzoSeleccion,
    empleados,
    empleadosAlmuerzoSeleccion
}) => {

    // * ESTADO DE LA SEMANA ACTUAL.
    const { estatus } = useSelector(selectSemanaAlmuerzoActiva);

    // * DESESTRUCTURACION DE DATOS
    const { diaId, position } = stepPosition;

    // * DIA SELECCIONADO.
    const dia = diasSemanas.find(x => x.id === diaId)?.descripcion ?? '';

    // * DIA NORMALIZADO
    const diaNormalizado = removeAccents(dia);

    // * FUNCION PARA PASAR DE PAGINAS.
    const nextPage = () => {

        if(diaId > 0){
            const validate = Object.entries(seleccionMenuEmpleado[diaNormalizado])?.some(([key, value]) => 
                typeof value === 'object' ? value.length > 0 : value
            );
            
            if(!validate && categoriaAlmuerzoDiaEmpleado?.length > 0){
                swal("Información", "Debe seleccionar al menos una opción.", "warning");
                return;
            }
        }

        // * PASAR AL SIGUIENTE DIA.
        setStepPosition({diaId: diaId + 1, position: position + 1 })
    }

    // * FUNCION PARA GUARDAR LA SELECCION DEL MENU.
    const saveSeleccionMenu = (value, categoria) => {

        // * CONVERTIR ID EN ENTERO.
        const id = parseInt(value);

        // * COMIDAS FILTRADAS POR LA CATEGORIA QUE RECIBE POR PARAMETRO EN LA FUNCION.
        const { comidas } = categoriaAlmuerzoDiaEmpleado.find(x => x.descripcion === categoria);

        // * OPCION NO APLICA PARA LAS DISTINTAS CATEGORIAS DIFERENTE A GUARNICION.
        const opcionNoAplicaEnsalada = categoriaAlmuerzoDiaEmpleado.find(x => x.descripcion === "Ensalada")?.comidas?.find(x => x.descripcion.toLowerCase() === "no aplica")?.comidaId;
        const opcionNoAplicaAcompañamiento = categoriaAlmuerzoDiaEmpleado.find(x => x.descripcion === "Acompañamiento")?.comidas?.find(x => x.descripcion.toLowerCase() === "no aplica")?.comidaId;
        const opcionNoAplicaGuarnicion = categoriaAlmuerzoDiaEmpleado.find(x => x.descripcion === "Guarnición")?.comidas?.find(x => x.descripcion.toLowerCase() === "no aplica")?.comidaId;

        // * OPCION COMIDA SELECCIONADA GUARNICION.
        const comidaSeleccionada = comidas.find(x => x.comidaId === id) ?? {};

        if(Object.keys(comidaSeleccionada).length > 0){

            // * DESESTRUCTURACION DE LOS DATOS.
            const { acompañamiento: Acompanamiento, ensalada: Ensalada, guarnicion: Guarnicion } = comidaSeleccionada;

            // * SELECION DE COMIDA DIA SELECCIONADO.
            let seleccionMenuUpdate = seleccionMenuEmpleado[diaNormalizado];

            // * ASIGNACION DE VALORES A OBJETO A MODIFICAR.
            seleccionMenuUpdate[removeAccents(categoria)] = id;
            seleccionMenuUpdate.Acompanamiento = Acompanamiento ? seleccionMenuUpdate['Acompanamiento'] ?? {} : opcionNoAplicaAcompañamiento; 
            seleccionMenuUpdate.Ensalada = Ensalada ? seleccionMenuUpdate['Ensalada'] ?? {} : opcionNoAplicaEnsalada; 
            seleccionMenuUpdate.Guarnicion = Guarnicion ? seleccionMenuUpdate['Guarnicion'] ?? {} : opcionNoAplicaGuarnicion; 

            // * LISTA DE COMIDAS POR DIA.
            const comidasEmpleado = categoriaAlmuerzoDiaEmpleado.map(x => x.comidas).flat();

            // * LISTA DE COMIDAS SELECCIONADAS POR EL USUARIO.
            const comidasSeleccionadasUsuario = Object.values(seleccionMenuEmpleado[diaNormalizado])
                .map(comidaId => comidasEmpleado.find(x => x.comidaId === comidaId) ?? {});

            // * VERIFICAR SI HAY ALGUNA COMIDA SELECCIONADA POR EL USUARIO DONDE TIENE RESTRINCION 
            // * DE CATEGORIAS.
            const comidaDeshabilitarCategorias = comidasSeleccionadasUsuario.find(x =>
                !x.acompañamiento || !x.ensalada || !x.guarnicion
            ) ?? {};

            // * SI ENCUENTRA ALGUNA COMIDA DONDE TIENE RESTRINCION PUES SE HACEN LOS AJUSTES CORRESPONDIENTES.
            if(Object.keys(comidaDeshabilitarCategorias).length > 0){

                // * DESESTRUCTURACION DE LOS DATOS.
                const { acompañamiento: Acompanamiento, ensalada: Ensalada, guarnicion: Guarnicion } = comidaDeshabilitarCategorias;
    
                // * ASIGNACION DE VALORES A OBJETO A MODIFICAR NUEVAMENTE.
                seleccionMenuUpdate.Acompanamiento = Acompanamiento ? seleccionMenuUpdate['Acompanamiento'] ?? {} : opcionNoAplicaAcompañamiento; 
                seleccionMenuUpdate.Ensalada = Ensalada ? seleccionMenuUpdate['Ensalada'] ?? {} : opcionNoAplicaEnsalada; 
                seleccionMenuUpdate.Guarnicion = Guarnicion ? seleccionMenuUpdate['Guarnicion'] ?? {} : opcionNoAplicaGuarnicion;
                
                // * ACTUALIZACION DE LOS NUEVOS VALORES.
                setSeleccionMenuEmpleado({
                    ...seleccionMenuEmpleado,
                    [diaNormalizado]: seleccionMenuUpdate
                })
            
                // * VALIDACION PARA ACTIVAR O DESACTIVAR LAS CATEGORIAS SEGUN LA COMIDA SELECCIONADA. 
                setDisabledCategoriesFood({...disabledCategoriesFood, [diaNormalizado]: { Acompanamiento, Ensalada, Guarnicion}});

                return;
            }

            // * ACTUALIZACION DE LOS NUEVOS VALORES.
            setSeleccionMenuEmpleado({
                ...seleccionMenuEmpleado,
                [diaNormalizado]: seleccionMenuUpdate
            })
            
            // * VALIDACION PARA ACTIVAR O DESACTIVAR LAS CATEGORIAS SEGUN LA COMIDA SELECCIONADA. 
            setDisabledCategoriesFood({...disabledCategoriesFood, [diaNormalizado]: { Acompanamiento, Ensalada, Guarnicion}});
        }
        else
        {
            swal("Error", "Opción inválida.", "error");
        }
        
    }

    // console.log(empleadosAlmuerzoSeleccion);
    

  return (
    <Paper>
        <Stack p={3} minHeight='80%'>
            <Typography variant='h6'>{position === 0 ? "Selección del Personal" : position < 6 ? dia : "Resumen del Menú de la semana"}</Typography>
            <Divider />

                {
                position === 0 &&
                    <>
                    
                        <Stack mt={2}>
                            <Typography fontWeight='bold'>Empleados</Typography>
                            <Autocomplete
                            value={empleadosAlmuerzoSeleccion}
                            multiple
                            id="tags-outlined"
                            options={empleados}
                            getOptionLabel={(option) => option.nombreCompleto}
                            filterSelectedOptions
                            onChange={(event, newValue) => {
                                setEmpleadosAlmuerzoSeleccion(newValue);
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label=" "
                                    placeholder="Empleado"
                                />
                            )}
                            className="mb-2"
                            />

                        </Stack>
                    
                    </>
                }

                {
                    position === 6 &&
                    <TableContainer component={Paper} sx={{mt: 3}}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{fontWeight: 'bold'}}>
                                        Día
                                    </TableCell>
                                    <TableCell sx={{fontWeight: 'bold'}}>
                                        Menú
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    diasSemanas.map(((x, index) => (
                                        <TableRow key={index}>
                                            <TableCell>
                                                {x.descripcion}
                                            </TableCell>
                                            <TableCell>
                                                {resumenMenuState[removeAccents(x.descripcion)]}
                                            </TableCell>
                                        </TableRow>
                                    )))
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                }
                
                {
                    categoriaAlmuerzoDiaEmpleado?.length > 0 ?

                        <Grid container spacing={4}>
                        {
                            categoriaAlmuerzoDiaEmpleado?.map((item, index) => (
                          
                                <Grid item xs={4} key={index}>  

                                    <FormControl sx={{mt: 2}}>
                                        <FormLabel id="demo-row-radio-buttons-group-label">{item.descripcion}</FormLabel>
                                            <RadioGroup
                                            value={seleccionMenuEmpleado[diaNormalizado]?.[removeAccents(item.descripcion)] || ""}
                                            onChange={e =>  saveSeleccionMenu(e.target.value, item.descripcion)}
                                            key={index}
                                            rownpm start
                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                            >
                                                {
                                                    item?.comidas?.map((item2, index2) => (
                                                        <FormControlLabel disabled={!estatus || (disabledCategoriesFood[diaNormalizado] && !disabledCategoriesFood[diaNormalizado][removeAccents(item.descripcion)])} key={index2} value={item2.comidaId} control={<Radio />} label={item2.descripcion} />
                                                    ))
                                                }
                                            
                                            </RadioGroup>
                                    </FormControl>


                                </Grid>

                            ))
                        }

                    </Grid>

                    : position < 5 > 1
                        ? <Typography mt={3} align='center'>No hay opciones disponibles</Typography>
                        : <></>
                       
                }
            
            <div className='mt-4 d-flex justify-content-end'>
                <button style={{marginRight: 4}} hidden={position === 0} onClick={() => setStepPosition({diaId: diaId - 1, position: position - 1 })} className='btn btn-primary-mem'><FaArrowCircleLeft style={{marginBottom: 4}} /> Anterior</button>
                <button hidden={position === 6} onClick={() =>  nextPage()} className='btn btn-primary-mem'>Siguiente <FaArrowCircleRight style={{marginBottom: 4}} /> </button>
                <button hidden={position < 6 || !estatus} onClick={() => sendDataToApi()} className='btn btn-primary-mem'>Guardar <BiSave style={{marginBottom: 3}} fontSize={22} /></button>
            </div>

        </Stack>
    </Paper>
  )
}
